



























import { MessageDialog } from '../../utils/MessageDialog';
import { Vue, Component, Prop } from 'vue-property-decorator';
import CourseSelectDialog from './CourseSelectDialog.vue';
import { TeacherService } from '../../biz/remote/TeacherService';
import { Session } from '../../utils/Session';
import { Teacher } from '../../../src_server/entity/generated/Teacher';
import { SupportPlanService } from '../../biz/remote/SupportPlanService';
import { DaTeacherService } from '../../biz/remote/DaTeacherService';
@Component({ components: { CourseSelectDialog } })
export default class CourseSelectPanel extends Vue {
  @Prop({ default: '' })
  private user_id!: string;

  @Prop({ default: false })
  forDisplay!: boolean;

  private teachers: Teacher[] = [];
  private courseList: string[] = [];
  /*
   * コース追加のダイアログを表示
   */
  async showAddCourseDialog() {
    (this.$refs['course-select-dialog'] as CourseSelectDialog).show(this.teachers, this.courseList);
  }

  courseTeacher(teacher_id: string) {
    return this.teachers.find((t) => t.user_id === teacher_id);
  }

  /**
   * コースを追加する
   */
  selectedCourse(selectedTeacher: string[]) {
    this.courseList = selectedTeacher;
  }

  /**
   * コースを削除する
   */
  async deleteCourse(course: Teacher) {
    await MessageDialog.alert('コースを削除しました。更新ボタンで保存してください。');
    this.courseList.splice(
      this.courseList.findIndex((teacher_id) => teacher_id === course.user_id),
      1
    );
  }

  async update() {
    const isOK = await MessageDialog.confirm(`選択コースを登録します。よろしいですか？`);
    if (isOK) {
      const biz = new DaTeacherService();
      await biz.updateSelectedCourse(this.user_id, this.courseList);
      await MessageDialog.alert(`登録しました。`);
    }
  }

  async created() {
    // DAの場合コース選択
    // コースマスタとる
    const teacherBiz = new TeacherService();
    const response = await teacherBiz.getDaMatchingClass(Session.getSessionBuildingId());
    this.teachers = response.data
      .filter((d) => d.teacher)
      .map((d) => {
        return d.teacher!;
      });

    // 自分の取得済みコースをとる
    const biz = new SupportPlanService();
    const courseResponse = await biz.getUserCourses(this.user_id);
    this.courseList = courseResponse.data.map((c) => c.teacher_user_id || '');
  }
}
